import { useState, useEffect } from "react";
import { GlobalStyles } from "@mui/material";
import axios from "axios";
import "../../.csscode/PopUpModal.css";
import { toast } from "sonner";
import Select from "react-select";
import { notificationUrl } from "../Constant";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import PopupInputField from "../PopupInputField";
import { fetchorgImageGeneral } from "../annexture/orgfetchUtils";
import CustomLoader from "../static/CustomLoader";
import { uploadDocument } from "../utiles/DocumentService";
const workItemStyles = {
  ".ptw-work-item .popupmodal-maindiv": {
    overflowY: "auto",
    overflowX: "hidden",
    boxSizing: "border-box",
    backgroundColor: "#FFFFFF",
    border: "1px solid #D9E2EA",
    borderRadius: "14px",
    boxShadow: "0 18px 50px rgba(15, 35, 55, 0.22)",
    padding: "18px",
  },
  ".ptw-work-item .form-container": { width: "100%", boxSizing: "border-box" },
  ".ptw-work-item .logo-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "56px",
    marginBottom: "6px",
  },
  ".ptw-work-item .logo-container img": {
    width: "auto !important",
    maxWidth: "180px !important",
    height: "42px !important",
    objectFit: "contain",
  },
  ".ptw-work-item .header-section": { marginBottom: "16px" },
  ".ptw-work-item .center-heading": {
    margin: "8px 0 14px",
    textAlign: "center",
    color: "#123B5D",
    fontSize: "24px",
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: "0.3px",
  },
  ".ptw-work-item .safety-table, .ptw-work-item .work-table, .ptw-work-item .precautions-table, .ptw-work-item .ppe-table, .ptw-work-item .permit-return-table":
    {
      width: "100%",
      borderCollapse: "collapse",
      borderSpacing: 0,
      backgroundColor: "#FFFFFF",
      fontSize: "13px",
      color: "#243746",
    },
  ".ptw-work-item .safety-table td": {
    border: "1px solid #DCE4EC",
    padding: "10px 12px",
    verticalAlign: "middle",
    backgroundColor: "#FAFCFE",
  },
  ".ptw-work-item .safety-table td:nth-child(2n)": {
    fontWeight: 600,
    color: "#123B5D",
  },
  ".ptw-work-item .work-description-section, .ptw-work-item .precautions-section, .ptw-work-item .ppe-section, .ptw-work-item .permit-signatures, .ptw-work-item .permit-return-section, .ptw-work-item .electrical-certificate-form__group, .ptw-work-item .file-upload-section":
    {
      marginTop: "14px",
      border: "1px solid #DCE4EC",
      borderRadius: "10px",
      overflow: "hidden",
      backgroundColor: "#FFFFFF",
    },
  ".ptw-work-item .work-description-section h3, .ptw-work-item .ppe-section h3, .ptw-work-item .permit-signatures h3, .ptw-work-item .permit-return-section h3, .ptw-work-item .electrical-certificate-form__group h3, .ptw-work-item .file-upload-section h3":
    {
      margin: 0,
      padding: "11px 14px",
      backgroundColor: "#EEF4F8",
      color: "#123B5D",
      fontSize: "15px",
      lineHeight: 1.35,
      fontWeight: 700,
      borderBottom: "1px solid #DCE4EC",
    },
  ".ptw-work-item .work-table td, .ptw-work-item .precautions-table td, .ptw-work-item .ppe-table td, .ptw-work-item .permit-return-table td":
    {
      border: "1px solid #DCE4EC",
      padding: "8px 10px",
      verticalAlign: "middle",
      backgroundColor: "#FFFFFF",
    },
  ".ptw-work-item .work-table label, .ptw-work-item .precautions-table label, .ptw-work-item .ppe-table label, .ptw-work-item .permit-return-table label":
    { color: "#243746", fontWeight: 600, fontSize: "12.5px" },
  ".ptw-work-item .precautions-table th, .ptw-work-item .ppe-table th, .ptw-work-item .permit-return-table th":
    {
      border: "1px solid #DCE4EC",
      padding: "9px 10px",
      backgroundColor: "#123B5D",
      color: "#FFFFFF",
      fontSize: "12px",
      fontWeight: 700,
      textAlign: "left",
      verticalAlign: "middle",
    },
  '.ptw-work-item input:not([type="radio"]):not([type="checkbox"]), .ptw-work-item textarea':
    {
      width: "100%",
      boxSizing: "border-box",
      minHeight: "38px",
      border: "1px solid #C9D6E2",
      borderRadius: "7px",
      padding: "8px 10px",
      backgroundColor: "#FFFFFF",
      color: "#1E2D3A",
      fontSize: "13px",
      outline: "none",
      transition: "border-color .18s ease, box-shadow .18s ease",
    },
  '.ptw-work-item input:not([type="radio"]):not([type="checkbox"]):focus, .ptw-work-item textarea:focus':
    { borderColor: "#7DA6C4", boxShadow: "0 0 0 3px rgba(18, 59, 93, 0.10)" },
  ".ptw-work-item textarea": { minHeight: "105px", resize: "vertical" },
  '.ptw-work-item input[type="radio"]': { accentColor: "#123B5D" },
  ".ptw-work-item .ptw-select__control": {
    minHeight: "38px",
    borderColor: "#C9D6E2",
    borderRadius: "7px",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
  },
  ".ptw-work-item .ptw-select__control:hover": { borderColor: "#AEBFCC" },
  ".ptw-work-item .ptw-select__control--is-focused": {
    borderColor: "#7DA6C4",
    boxShadow: "0 0 0 3px rgba(18, 59, 93, 0.10)",
  },
  ".ptw-work-item .ptw-select__placeholder": {
    color: "#8A99A8",
    fontSize: "13px",
  },
  ".ptw-work-item .ptw-select__single-value": {
    color: "#243746",
    fontSize: "13px",
  },
  ".ptw-select__menu-portal": { zIndex: 16000 },
  ".ptw-work-item .ptw-select__menu": {
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 12px 30px rgba(15, 35, 55, 0.16)",
    border: "1px solid #DCE4EC",
  },
  ".ptw-work-item .ptw-select__option": { fontSize: "13px" },
  ".ptw-work-item .react-time-picker": { width: "100%" },
  ".ptw-work-item .react-time-picker__wrapper": {
    minHeight: "38px",
    boxSizing: "border-box",
    border: "1px solid #C9D6E2",
    borderRadius: "7px",
    padding: "3px 9px",
    backgroundColor: "#FFFFFF",
  },
  ".ptw-work-item .react-time-picker__inputGroup__input": {
    color: "#243746",
    fontSize: "13px",
  },
  ".ptw-work-item .error-message, .ptw-work-item .electrical-certificate-form__group p":
    {
      display: "block",
      margin: "5px 0 0",
      color: "#D32F2F !important",
      fontSize: "11.5px",
      lineHeight: 1.35,
    },
  ".ptw-work-item .file-upload-section": { paddingBottom: "14px" },
  ".ptw-work-item .file-upload-container": {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    padding: "14px",
    alignItems: "stretch",
  },
  ".ptw-work-item .file-upload-box": {
    flex: "1 1 260px",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "12px",
    boxSizing: "border-box",
    border: "1px dashed #B8C8D6",
    borderRadius: "8px",
    backgroundColor: "#F8FAFC",
  },
  '.ptw-work-item .file-upload-box input[type="file"]': {
    width: "100%",
    minHeight: "38px",
    border: "1px solid #C9D6E2",
    borderRadius: "7px",
    padding: "5px",
    boxSizing: "border-box",
    backgroundColor: "#FFFFFF",
    color: "#4B5E6D",
  },
  ".ptw-work-item .file-preview-box": {
    minWidth: "180px",
    maxWidth: "280px",
    padding: "10px 12px",
    border: "1px solid #DCE4EC",
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 8px rgba(15, 35, 55, 0.05)",
  },
  ".ptw-work-item .file-preview-box p": {
    margin: 0,
    fontSize: "12px",
    color: "#33485C",
    wordBreak: "break-word",
  },
  ".ptw-work-item .form-buttons": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    padding: "16px 0 2px",
    borderTop: "1px solid #E5EBF0",
    marginTop: "14px",
  },
  ".ptw-work-item .submit-btn, .ptw-work-item .cancel-btn": {
    minWidth: "96px",
    minHeight: "38px",
    border: "none",
    borderRadius: "7px",
    padding: "8px 18px",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer",
    transition:
      "transform .15s ease, box-shadow .15s ease, background-color .15s ease",
  },
  ".ptw-work-item .submit-btn": {
    backgroundColor: "#16845B",
    color: "#FFFFFF",
  },
  ".ptw-work-item .submit-btn:hover": {
    backgroundColor: "#126F4C",
    boxShadow: "0 4px 12px rgba(22, 132, 91, 0.18)",
  },
  ".ptw-work-item .cancel-btn": {
    backgroundColor: "#D64545",
    color: "#FFFFFF",
  },
  ".ptw-work-item .cancel-btn:hover": {
    backgroundColor: "#BC3535",
    boxShadow: "0 4px 12px rgba(214, 69, 69, 0.18)",
  },
  "@media (max-width: 900px)": {
    ".ptw-work-item .popupmodal-maindiv": {
      width: "calc(100vw - 20px)",
      maxHeight: "calc(100vh - 20px)",
      padding: "12px",
      borderRadius: "10px",
    },
    ".ptw-work-item .safety-table, .ptw-work-item .work-table, .ptw-work-item .precautions-table, .ptw-work-item .ppe-table, .ptw-work-item .permit-return-table":
      { minWidth: "720px" },
    ".ptw-work-item .work-description-section, .ptw-work-item .precautions-section, .ptw-work-item .ppe-section, .ptw-work-item .permit-signatures, .ptw-work-item .permit-return-section":
      { overflowX: "auto" },
  },
};

const WorkItem = ({ onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [formData, setFormData] = useState({
    workType: "hotWork",
  });
  const envCode = localStorage.getItem("envcode") || "Prod";
  const orgcode = localStorage.getItem("custCode") || "ptw";
  const [orgImg, setOrgImg] = useState("");
  const [userName, setUsername] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [userId, setUserId] = useState("");
  const [empType, setEmpType] = useState("");
  const [divisionData, setDivisionData] = useState([]);
  const [selecteDepartment, setSelectedDepartment] = useState(null);
  const [assignedUserOptions, setAssignedUserOptions] = useState([]);
  useEffect(() => {
    fetchData();
    fetchUserData();
    fetchDivisions();
    fetchUserOptions();
  }, []);
  const fetchUserData = async () => {
    try {
      const savedUser = localStorage.getItem("user");
      if (savedUser) {
        const parsedUser = JSON.parse(savedUser);
        setUserId(parsedUser.empcode);
        setEmpType(parsedUser.type);
        setUsername(parsedUser.userid);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  const fetchUserOptions = async () => {
    try {
      const response = await axios.get(`${apiUrl}user`, { headers });
      setAssignedUserOptions(
        response.data.map((user) => ({
          value: user.empcode,
          label: user.userid,
        })),
      );
    } catch (error) {
      toast.error("Failed to fetch users.");
    }
  };
  const fetchData = async () => {
    try {
      const savedOrg = localStorage.getItem("org");
      if (savedOrg) {
        const parsedOrg = JSON.parse(savedOrg);
        const fileUrl = await fetchorgImageGeneral(
          parsedOrg.logo,
          parsedOrg.code,
        );
        setOrgImg(fileUrl);
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    }
  };
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter(
      (file) => file.size < 5 * 1024 * 1024,
    );
    if (validFiles.length < selectedFiles.length) {
      toast.warning("Some files exceed the size limit and were not added.");
    }
    setAttachedFiles((prev) => [...prev, ...validFiles]);
  };
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleTimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      timeTo: value,
    }));
  };
  const handleTimeFromChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      timeFrom: value,
    }));
  };
  const handlePermitTimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitauthtimefrom: value,
    }));
  };
  const handlePermitTimeToChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitauthtimeto: value,
    }));
  };
  const handlePermitwcapplicanttimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcapplicanttime: value,
    }));
  };
  const handlePermitwcAuthorisertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcAuthorisertime: value,
    }));
  };
  const handlePermitwncholdertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncholdertime: value,
    }));
  };
  const handlePermitwncapplicanttimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncapplicanttime: value,
    }));
  };
  const handlePermitwncAuthorisertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwncAuthorisertime: value,
    }));
  };
  const handlePermitwcholdertimeChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      permitwcholdertime: value,
    }));
  };
  const validateFields = () => {
    let newErrors = {};
    if (!selecteDepartment) {
      newErrors.department = "Please select department.";
    }
    if (!formData.workComments || formData.workComments.trim() === "") {
      newErrors.workComments = "Please enter your comments.";
    }
    if (
      formData.dateFrom &&
      formData.dateTo &&
      formData.timeFrom &&
      formData.timeTo
    ) {
      const fromDateTime = new Date(
        `${formData.dateFrom}T${formData.timeFrom}`,
      );
      const toDateTime = new Date(`${formData.dateTo}T${formData.timeTo}`);
      if (toDateTime <= fromDateTime) {
        newErrors.timeTo = "To date/time must be greater than From date/time.";
      }
    }
    if (
      formData.permitauthdatefrom &&
      formData.permitauthdateto &&
      formData.permitauthtimefrom &&
      formData.permitauthtimeto
    ) {
      const fromDateTime = new Date(
        `${formData.permitauthdatefrom}T${formData.permitauthtimefrom}`,
      );
      const toDateTime = new Date(
        `${formData.permitauthdateto}T${formData.permitauthtimeto}`,
      );
      if (toDateTime <= fromDateTime) {
        newErrors.permitauthdateto =
          "Permit end date/time must be after start date/time.";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const fetchDivisions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}division`, {
        headers,
      });
      const divOptions = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setDivisionData(divOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit = async () => {
    if (!validateFields()) {
      toast.warning("Please fill in the required fields before submitting!");
      setLoading(false);
      return;
    }
    setLoading(true);
    const finalComment = `${userName}: ${formData.workComments}`;
    const finalFormData = {
      ...formData,
      workComments: finalComment,
    };
    const formattedFormData = {
      0: finalFormData,
    };
    const requestData = {
      workItem: {
        type: empType,
        status: 1,
        comment: JSON.stringify(formattedFormData),
        createuser: userId,
        lastupdateuser: userId,
        department: formData.plant,
      },
      workListHist: {
        userName: userName,
      },
      workDoc: [],
    };
    try {
      const response = await axios.post(`${apiUrl}worklist`, requestData, {
        headers: {
          Authorization: `Bearer ${dbTokenData}`,
          "Content-Type": "application/json",
          dbMaster: "",
          Department: selecteDepartment,
        },
      });
      if (response.data.cd === 1) {
        toast.error(response.data.description);
      } else {
        const workid = response.data.workid;
        const uploadedDocs = [];
        for (let i = 0; i < attachedFiles.length; i++) {
          const file = attachedFiles[i];
          try {
            const folderPath = `${orgcode}/ptw\_${workid}`;
            const uploadRes = await uploadDocument({
              file,
              projectCode: "Ptw",
              envCode,
              folderPath,
            });
            if (uploadRes?.cd === 1) {
              toast.error(uploadRes.description);
              setLoading(false);
              return;
            }
            uploadedDocs.push({
              doc: uploadRes,
              name: file.name,
              type: file.type,
            });
            toast.success(`File ${file.name} uploaded successfully!`);
          } catch (uploadErr) {
            console.error(`Error uploading ${file.name}:`, uploadErr);
            toast.error(`Upload failed for ${file.name}`);
          }
        }
        if (uploadedDocs.length > 0) {
          const docNames = uploadedDocs.map((d) => d.doc).join(",");
          const fileNames = uploadedDocs.map((d) => d.name).join(",");
          const fileTypes = uploadedDocs.map((d) => d.type).join(",");
          const workDocSave = {
            workid: workid,
            doc: docNames,
            name: fileNames,
            type: fileTypes,
          };
          try {
            const resp = await axios.post(`${apiUrl}workdoc`, workDocSave, {
              headers: {
                Authorization: `Bearer ${dbTokenData}`,
                "Content-Type": "application/json",
                dbMaster: "",
              },
            });
            if (resp.data.cd === 1) {
              toast.error("Failed to save documents.");
            } else {
              toast.success("Documents saved Successfully.");
            }
          } catch (e) {
            console.warn("Could not save workDoc", e);
          }
        }
        toast.success("PTW Request Submitted Successfully.");
        sendNotification(workid, response.data.assigneduser);
        onHide();
        setRefresh(true);
        setAttachedFiles([]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Some Issue Please Check..");
    } finally {
      setLoading(false);
    }
  };
  const getLabelFromValue = (value, options) => {
    const option = options.find((option) => option.value === value);
    return option ? option.label : value;
  };
  const sendNotification = async (workId, assignedUser) => {
    const user = getLabelFromValue(assignedUser, assignedUserOptions);
    try {
      await axios.post(
        `${notificationUrl}?userid=${user}&taskcode=${workId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
    toast.success("Notification is sent to Assigned User.");
  };
  const handleDepartmentChange = (selectedOption) => {
    if (selectedOption) {
      const selectedRoleValue = selectedOption.label;
      setSelectedDepartment(selectedRoleValue);
    } else {
      setSelectedDepartment(null);
    }
  };
  return (
    <>
      <GlobalStyles styles={workItemStyles} />
      {loading && <CustomLoader />}
      <div className="ptw-work-item">
        <div className="popupmodal-overlay">
          <div className="popupmodal-maindiv">
            <div className="form-container">
              <div className="logo-container">
                <img
                  src={orgImg}
                  alt="Organization Logo"
                  style={{
                    width: "130px",
                    height: "50px",
                    backgroundColor: "transparent",
                    borderRadius: "2px",
                  }}
                />
              </div>
              <div className="header-section">
                <h2 className="center-heading">PERMIT TO WORK</h2>
                <table className="safety-table">
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="radio"
                          checked={formData.workType === "hotWork"}
                          name="workType"
                          value="hotWork"
                          onChange={handleChange}
                        />
                      </td>
                      <td>Hot Work</td>
                      <td>
                        <input
                          type="radio"
                          checked={formData.workType === "coldWork"}
                          name="workType"
                          value="coldWork"
                          onChange={handleChange}
                        />
                      </td>
                      <td>Cold Work</td>
                      <td>
                        <Select
                          value={
                            divisionData.find(
                              (option) => option.label === selecteDepartment,
                            ) || null
                          }
                          onChange={handleDepartmentChange}
                          placeholder="Department"
                          options={divisionData}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          classNamePrefix="ptw-select"
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 999999,
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 999999,
                              backgroundColor: "#FFFFFF",
                              display: "block",
                            }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: "250px",
                              backgroundColor: "#FFFFFF",
                              display: "block",
                            }),
                            option: (base, state) => ({
                              ...base,
                              display: "block",
                              backgroundColor: state.isFocused
                                ? "#EEF4F8"
                                : "#FFFFFF",
                              color: "#243746",
                              cursor: "pointer",
                              padding: "10px 12px",
                            }),
                          }}
                        />
                        {errors.department && (
                          <span className="error-message">
                            {errors.department}
                          </span>
                        )}{" "}
                      </td>
                      <td>Department</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="work-description-section">
                <h3>Application and Work Description</h3>
                <table className="work-table">
                  <tbody>
                    <tr>
                      <td>
                        <label>Plant:</label>
                      </td>
                      <td>
                        {" "}
                        <PopupInputField
                          type="text"
                          name="plant"
                          value={formData.plant || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <label>Date From:</label>
                      </td>
                      <td>
                        <input
                          type="date"
                          name="dateFrom"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <label>Date To:</label>
                      </td>
                      <td>
                        <input
                          type="date"
                          name="dateTo"
                          onChange={handleChange}
                        />
                        {errors.dateTo && (
                          <span style={{ color: "red" }}>{errors.dateTo}</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Location:</label>
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="location"
                          value={formData.location || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <label>Time From:</label>
                      </td>
                      <td>
                        <TimePicker
                          onChange={handleTimeFromChange}
                          value={formData.timeFrom}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                      <td>
                        <label>Time To:</label>
                      </td>
                      <td>
                        <TimePicker
                          onChange={handleTimeChange}
                          value={formData.timeTo}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                        {errors.timeTo && (
                          <span style={{ color: "red" }}>{errors.timeTo}</span>
                        )}
                      </td>
                    </tr>
                    {/* Fourth Row */}
                    <tr>
                      <td colSpan="6">
                        <label style={{ fontWeight: "bold" }}>
                          Work Description:
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="6">
                        <textarea
                          rows="4"
                          name="workDescription"
                          style={{ width: "100%" }}
                          onChange={handleChange}
                        ></textarea>
                      </td>
                    </tr>
                    {/* Fifth Row - Applicant Details */}
                    <tr>
                      <td colSpan="6">
                        <label style={{ fontWeight: "bold" }}>Applicant:</label>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <label>Name:</label>
                      </td>
                      <td colSpan="2">
                        <PopupInputField
                          type="text"
                          name="applicantName"
                          value={formData.applicantName || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <label>Sign:</label>
                      </td>
                      <td colSpan="2">
                        <PopupInputField
                          type="text"
                          name="applicantSign"
                          value={formData.applicantSign || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Special Precautions Section */}
              <div className="precautions-section">
                <table className="precautions-table">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>
                        Safety Measures Taken By Operations
                      </th>
                      <th>Remarks</th>
                      <th>Special Precautions & Potential Hazards</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Equipment is free from Flammable/Hydrocarbon/Toxic gases
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety1"
                          value={formData.safety1 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard1"
                          value={formData.hazard1 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Equipment properly drained, cleaned</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety2"
                          value={formData.safety2 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard2"
                          value={formData.hazard2 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Water seal has been made</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety3"
                          value={formData.safety3 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard3"
                          value={formData.hazard3 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Bleeders have been opened</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety4"
                          value={formData.safety4 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard4"
                          value={formData.hazard4 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Nitrogen purging has been done</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety5"
                          value={formData.safety5 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard5"
                          value={formData.hazard5 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Radioactive sources protected</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety6"
                          value={formData.safety6 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard6"
                          value={formData.hazard6 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Name/Sign</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="safety7"
                          value={formData.safety7 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="hazard7"
                          value={formData.hazard7 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* PPE, Fire Precautions, Gas Tests, Certificates */}
              <div className="ppe-section">
                <h3>
                  3\. PPE, Fire Precautions, Gas Tests & Associated Certificates
                </h3>
                <table className="ppe-table">
                  <thead>
                    <tr>
                      <th style={{ width: "15%" }}>3A - PPE & Others</th>
                      <th>Remarks</th>
                      <th style={{ width: "15%" }}>
                        3B - Fire Precautions & Gas Tests
                      </th>
                      <th>Remarks</th>
                      <th>3C - Certificates</th>
                      <th>Certificate Nos.</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Eye, Face & Ear Protection</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe1"
                          value={formData.ppe1 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Competent Fire Watcher</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution1"
                          value={formData.firePrecaution1 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Confined Space Entry</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate1"
                          value={formData.certificate1 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Head Protection</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe2"
                          value={formData.ppe2 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Fire Extinguishers</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution2"
                          value={formData.firePrecaution2 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>LOTO</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate2"
                          value={formData.certificate2 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Body Protection, Full Body Safety hamess</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe3"
                          value={formData.ppe3 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Pressure Fire Hose</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution3"
                          value={formData.firePrecaution3 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Electrical</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate3"
                          value={formData.certificate3 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Respiratory Protection (BA set)</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe4"
                          value={formData.ppe4 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Fire Tender</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution4"
                          value={formData.firePrecaution4 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Working at Height</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate4"
                          value={formData.certificate4 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Leg Protection</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe5"
                          value={formData.ppe5 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Screen off Area</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution5"
                          value={formData.firePrecaution5 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Excavation/Scaffding</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate5"
                          value={formData.certificate5 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>portable CO monitor</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe6"
                          value={formData.ppe6 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Explosive Test</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution6"
                          value={formData.firePrecaution6 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Heavy Lift/Hydra</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate6"
                          value={formData.certificate6 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Roof ledder/Gas cutting Sets</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe7"
                          value={formData.ppe7 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Carbone Monaxide Test</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution7"
                          value={formData.firePrecaution7 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Road Closure</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate7"
                          value={formData.certificate7 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Safe means of acess/Scaffolding/Enclosures</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="ppe8"
                          value={formData.ppe8 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Oxygen Test</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="firePrecaution8"
                          value={formData.firePrecaution8 || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>Radiography</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="certificate8"
                          value={formData.certificate8 || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Permit Applicant and Holder Section */}
              <div className="permit-signatures">
                <h3>Permit Applicant & Permit Holder</h3>
                <table className="work-table">
                  <tbody>
                    {/* First Row */}
                    <tr>
                      <td style={{ width: "15%" }}>
                        {" "}
                        <label>Permit Applicant Name: </label>
                      </td>
                      <td>
                        {" "}
                        <PopupInputField
                          type="text"
                          name="permitappname"
                          value={formData.permitappname || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td style={{ width: "5%" }}>
                        {" "}
                        <label> Sign: </label>
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitappsign"
                          value={formData.permitappsign || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    {/* Second Row */}
                    <tr>
                      <td>
                        {" "}
                        <label>Permit Holder Name: </label>
                      </td>
                      <td>
                        {" "}
                        <PopupInputField
                          type="text"
                          name="permitholdname"
                          value={formData.permitholdname || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <label>Sign: </label>
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitholdsign"
                          value={formData.permitholdsign || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="permit-signatures">
                <h3>Permit Authoriser Permit Validity</h3>
                <table className="work-table">
                  <tbody>
                    {/* First Row */}
                    <tr>
                      <td style={{ width: "10%" }}>
                        {" "}
                        <label>Date From: </label>
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitauthdatefrom"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        {" "}
                        <label>Date To: </label>
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitauthdateto"
                          onChange={handleChange}
                        />
                        {errors.permitauthdateto && (
                          <span style={{ color: "red" }}>
                            {errors.permitauthdateto}
                          </span>
                        )}
                      </td>
                      <td>
                        {" "}
                        <label>Name: </label>
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitauthname"
                          value={formData.permitauthname || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                    {/* Second Row */}
                    <tr>
                      <td>
                        {" "}
                        <label>Time From: </label>
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitTimeChange}
                          value={formData.permitauthtimefrom}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                      <td>
                        {" "}
                        <label>Time To: </label>
                      </td>
                      <td>
                        {" "}
                        <TimePicker
                          onChange={handlePermitTimeToChange}
                          value={formData.permitauthtimeto}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                        {errors.permitauthtimeto && (
                          <span style={{ color: "red" }}>
                            {errors.permitauthtimeto}
                          </span>
                        )}
                      </td>
                      <td>
                        {" "}
                        <label>Sign: </label>
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitauthsign"
                          value={formData.permitauthsign || ""}
                          onChange={handleChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Permit Return and Cancellation */}
              <div className="permit-return-section">
                <h3>4A Permit Return - Work Complete</h3>
                <table className="permit-return-table">
                  <thead>
                    <tr>
                      <th style={{ width: "30%" }}>Description</th>
                      <th>Name</th>
                      <th>Sign</th>
                      <th>Date</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Permit Return by Permit Holder, Work Complete. Work Site
                        & Equipment affected Left in Safe Condition
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcholdersign"
                          value={formData.permitwcholdersign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcholdername"
                          value={formData.permitwcholdername || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwcholderdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwcholdertimeChange}
                          value={formData.permitwcholdertime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Permit return by Applicant</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcapplicantsign"
                          value={formData.permitwcapplicantsign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcapplicantname"
                          value={formData.permitwcapplicantname || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwcapplicantdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwcapplicanttimeChange}
                          value={formData.permitwcapplicanttime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Permit Accepted by Authoriser</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcAuthorisersign"
                          value={formData.permitwcAuthorisersign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwcAuthorisername"
                          value={formData.permitwcAuthorisername || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwcAuthoriserdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwcAuthorisertimeChange}
                          value={formData.permitwcAuthorisertime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    {/* Add more rows */}
                  </tbody>
                </table>
              </div>
              {/* Permit Return and Cancellation */}
              <div className="permit-return-section">
                <h3>4B Permit Return - Work Not Complete</h3>
                <table className="permit-return-table">
                  <thead>
                    <tr>
                      <th style={{ width: "30%" }}>Description</th>
                      <th>Name</th>
                      <th>Sign</th>
                      <th>Date</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        Permit Return by Permit Holder, Work Not Complete(WNC).
                        Work Site & Equipment affected Left in Safe Condition
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncholdersign"
                          value={formData.permitwncholdersign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncholdername"
                          value={formData.permitwncholdername || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwncholderdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwncholdertimeChange}
                          value={formData.permitwncholdertime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Permit return by Applicant</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncapplicantsign"
                          value={formData.permitwncapplicantsign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncapplicantname"
                          value={formData.permitwncapplicantname || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwncapplicantdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwncapplicanttimeChange}
                          value={formData.permitwncapplicanttime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Permit Accepted by Authoriser</td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncAuthorisersign"
                          value={formData.permitwncAuthorisersign || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <PopupInputField
                          type="text"
                          name="permitwncAuthorisername"
                          value={formData.permitwncAuthorisername || ""}
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <input
                          type="date"
                          name="permitwncAuthoriserdate"
                          onChange={handleChange}
                        />
                      </td>
                      <td>
                        <TimePicker
                          onChange={handlePermitwncAuthorisertimeChange}
                          value={formData.permitwncAuthorisertime}
                          format="h:mm a"
                          disableClock={true}
                          clearIcon={null}
                        />
                      </td>
                    </tr>
                    {/* Add more rows */}
                  </tbody>
                </table>
              </div>
              <div className="electrical-certificate-form__group">
                <h3>Comments</h3>
                <textarea
                  rows="4"
                  cols="50"
                  name="workComments"
                  value={formData.workComments || ""}
                  style={{ border: errors.workComments ? "2px solid red" : "" }}
                  onChange={handleChange}
                />
                {errors.workComments && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {errors.workComments}
                  </p>
                )}
              </div>
              <div className="file-upload-section">
                <h3>Upload Documents (You can attach multiple files)</h3>
                <div className="file-upload-container">
                  <div className="file-upload-box">
                    <input
                      type="file"
                      name="files"
                      multiple
                      accept=".pdf, .png, .jpg"
                      onChange={handleFileChange} // Handle file selection
                    />
                    <span className="plus-icon">+</span>
                  </div>
                  {attachedFiles.map((file, index) => (
                    <div key={index} className="file-preview-box">
                      <p>{file.name}</p>
                    </div>
                  ))}
                </div>
              </div>
              {/* Buttons for Submit and Print */}
              <div className="form-buttons">
                <button
                  className="submit-btn"
                  disabled={loading}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default WorkItem;
